import React, { Component } from 'react';
import { ThemeModeContext } from '../contexts/theme-mode-ctx/theme-mode-ctx';

export const withThemeMode = WrappedComponent => (
  class withThemeModeUI extends Component {
    static contextType = ThemeModeContext;

    render() {
      const { themeMode, switchMode } = this.context;

      return <WrappedComponent {...this.props} themeMode={themeMode} switchMode={switchMode} />;
    }
  }
);
